<template>
    <div class="discuss-history-list">
        <!-- 1、时间:::Todo:::时间显示规则 -->
        <!-- <div class="discuss-history-list-time">2019年4月3日 16:28</div> -->

        <!-- 1、未登录状态 -->
        <div v-if="!hasLogined" class="discuss-history-list-note">
            <p>登录中...</p>
            <p>快分享给好友一起来论盘吧！</p>
        </div>
        <!-- 2、已登录，无论盘记录状态 -->
        <div v-if="hasLogined && lunpanHistoryList.length == 0">
            <div class="discuss-title">论盘标题:<span class="discuss-title-span">{{lunpanData.title}}</span><i v-if="lunpanData.edit == 1" class="iconfont icon-edit" @click.stop='clickEdit'></i></div>
            <div class="discuss-history-list-note">
                <p>还没有论盘记录诶～</p>
                <p>快分享给好友一起来论盘吧！</p>
            </div>
        </div>
        <!-- 3、已登录，有论盘记录状态 -->
        <div v-if="lunpanHistoryList.length > 0" class="discuss-title">论盘标题:<span class="discuss-title-span">{{lunpanData.title}}</span><i v-if="lunpanData.edit == 1" class="iconfont icon-edit" @click.stop='clickEdit'></i></div>
        <div v-if="lunpanHistoryList.length > 0" class="discuss-history-list-box" @click="clickList">
            <virtual-list
                ref="vsl"
                id="DiscussList"
                class="discuss-history-list-scroll"
                :data-key="'id'"
                :data-sources="lunpanHistoryList"
                :data-component="itemComponent"

                :estimate-size="20"
                :wrap-class="'discuss-history-list'"
                :header-class="'famous-list-note'"
                v-on:scroll='onScroll'
                v-on:totop="onScrollToTop">
                <div v-show="lunpanRefreshing" slot="header" class="lds-dual-ring lds-dual-ring-gray"></div>
            </virtual-list>
        </div>
        <!-- 4、论盘结束状态 -->
        <div v-if="lunpanData.isEnd == 1" class="discuss-end-note">----该论盘已结束----</div>
    </div>
</template>

<script>
import { WEIXIN } from '../../modules/weixin';
import DiscussItem from '../../components/discuss/DiscussItem.vue'
export default {
    name: 'DiscussHistoryList',
    computed: {
        hasLogined() {
            return this.$store.state.discuss.hasLogined;
        },
        lunpanData() {
            return this.$store.state.discuss.lunpanData;
        },
        lunpanHistoryList() {
            return this.$store.state.discuss.lunpanHistoryList;
        },
        lunpanRefreshing() {
            return this.$store.state.discuss.lunpanRefreshing;
        }
    },
    components: { DiscussItem },
    data() {
        return {
            itemComponent: DiscussItem,
        }
    },
    mounted() {
        var me = this;
        setTimeout(() => {
            me.initDom();
        }, 1000);
        this.$bus.on('initDiscussHistoryList', this.initDom);
        this.$bus.on('scrollToDiscussBottom', this.scrollToBottom);
        this.$bus.on('scrollToDiscussAssignPosByIndex', this.scrollToAssignPosByIndex);
    },
    destroyed() {
        this.$bus.off('initDiscussHistoryList', this.initDom);
        this.$bus.off('scrollToDiscussBottom', this.scrollToBottom);
        this.$bus.off('scrollToDiscussAssignPosByIndex', this.scrollToAssignPosByIndex);
    },
    methods: {
        initDom() {
            var listDiv = document.getElementById('DiscussList'),
                topDiv = document.getElementsByClassName('discuss-fate-topbar')[0],
                titleDiv = document.getElementsByClassName('discuss-title')[0],
                bottomDiv = document.getElementsByClassName('discuss-bottom-bar-box')[0];
            setTimeout(() => {
                var height = topDiv ? innerHeight - topDiv.clientHeight : innerHeight;
                    height = titleDiv ? height - titleDiv.clientHeight : height;
                    height = bottomDiv ? height - bottomDiv.clientHeight : height;

                if(titleDiv && topDiv) {
                    titleDiv.style.top = topDiv.clientHeight + 'px';
                }
                if(listDiv) {
                    listDiv.style.height = height + 'px';
                }
            }, 0);
        },
        clickEdit() {
            this.$store.state.discuss.showDiscussEditPop = true;
        },
        clickList() {
            this.$bus.emit('hideDiscussBubble');
        },
        onScroll() {
            this.$bus.emit('hideDiscussBubble');
        },
        onScrollToTop() {
            var me = this,
                lunpanGetAll = this.$store.state.discuss.lunpanGetAll;
            console.log('下拉刷新::::::', lunpanGetAll)
            this.$store.state.discuss.lunpanRefreshing = true;
            setTimeout(() => {
                if(lunpanGetAll) {
                    // 已经拉取完了就不要再拉了～
                    me.$store.state.discuss.lunpanRefreshing = false;
                }else {
                    me.$store.dispatch('discuss/refreshHistoryMsgList');
                }
            }, 500);
        },
        scrollToBottom() {
            if(this.$refs.vsl) {
                this.$refs.vsl.scrollToBottom();
            }
        },
        scrollToAssignPosByIndex(index) {
            console.error('scrollToAssignPosByIndex-----', index, this.lunpanHistoryList.length)
            var me = this;
            if(this.$refs.vsl) {
                this.$refs.vsl.scrollToBottom();
                setTimeout(() => {
                    me.$refs.vsl.scrollToIndex(index);
                }, 20);
            }
        }
    }
}
</script>